import { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { Route, Routes } from "react-router-dom";
import {
  AddIcon
  // ClockCardIcon,
  // DownloadIcon,
  // LocationCardIcon,
  // ReviewCardIcon
} from "../../Assets/assets";
import BreadCrumbs from "../../Components/BreadCrumbs/BreadCrumbs";
import Button from "../../Components/Button/Button";
// import { GraphCard, InfoCard, LegendCard } from "../../Components/Cards/Cards";
import MultipleSelect from "../../Components/Filters/MultipleSelect";
// import SearchBox from "../../Components/SearchBox/SearchBox";
import Table from "../../Components/Table/Table";
import { useResizeObserver } from "../../CustomHooks/useResizeObserver";
import {
  createProcedurePreset,
  editProcedurePreset
} from "../../Redux/procedures/action";
import {
  setSelectedTableData,
  setTableFilter,
  setTableSearchKey,
  setTableSort
} from "../../Redux/table/action";

import { isValidObject } from "../../Services/validators";
import { isFilterApplied } from "../../Utils/Constants/Constants";
import {
  convertToTableData,
  defaultProcedureFilter,
  proceduresFilterData,
  proceduresTableHeadings,
  procedureTableField
} from "../../Utils/Constants/Procedures";
import CreateProcedure from "./CreateProcedure";
import { setErrorStatus } from "../../Redux/status/action";
// import LineChart from "../../Components/Graphs/LineChart";
// import { DoughnutChart } from "../../Components/Graphs/DoughnutChart";

function Procedures(props) {
  const [selectedFilters, setSelectedFilters] = useState(
    defaultProcedureFilter
  );
  const [collapse, setCollapse] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const tableContainerRef = useRef(null);
  const filterContainerRef = useRef(null);
  const { height } = useResizeObserver(filterContainerRef);
  const [isResetSingleKey, setIsResetSingleKey] = useState(false);

  useEffect(() => {
    if (!isResetSingleKey) {
      setSelectedFilters(props.table.procedures.filter);
    }
  }, [props.table.procedures.filter, isResetSingleKey]);

  const handleApplyClick = () => {
    props.setTableFilter("PROCEDURES", selectedFilters);
  };

  const handleResetClick = (key) => {
    setIsResetSingleKey(true);
    setSelectedFilters({
      ...selectedFilters,
      [key]: defaultProcedureFilter[key]
    });
    props.setTableFilter("PROCEDURES", {
      ...props.table.procedures.filter,
      [key]: defaultProcedureFilter[key]
    });
  };

  const handleClearClick = () => {
    props.setTableFilter("PROCEDURES", defaultProcedureFilter);
    props.setTableSearchKey("PROCEDURES", "");
    setSelectedFilters(defaultProcedureFilter);
  };

  const handleDisableFilter = () => {
    return window.location.pathname.split("/")[3] ? true : false;
  };

  return (
    <>
      <Routes>
        <Route
          path="/:procedureId"
          element={
            <CreateProcedure
              navigate={props.navigate}
              selectedProcedure={
                props.procedures.data?.[
                  props.table.procedures?.selectedProcedure
                ]
              }
              saveOnClick={(data) => {
                if (props.claims?.procedures?.update) {
                  props.editProcedurePreset(data, props.navigate);
                } else {
                  setErrorStatus({
                    code: "custom",
                    message: "No permission to update procedures"
                  });
                }
              }}
              headerTextButtonOnClick={() => {
                props.navigate("/procedures");
              }}
              HeaderButtonText="Cancel Edit"
            />
          }
        />
        {props.claims?.procedures?.create ? (
          <Route
            path="/createProcedure"
            element={
              <CreateProcedure
                navigate={props.navigate}
                saveOnClick={props.createProcedurePreset}
              />
            }
          />
        ) : (
          <></>
        )}
      </Routes>
      <div
        className="inherit-parent-height inherit-parent-width position-relative overflow-hidden"
        ref={tableContainerRef}
      >
        <div className="inherit-parent-width">
          <div className="display-flex flex-justify-content-space-between flex-align-items-center">
            <BreadCrumbs />
            <div className="display-flex">
              {props.claims?.procedures?.create ? (
                <div className="padding-right-default">
                  <Button
                    text="New Procedure"
                    data-cy="CREATE-NEW-PROCEDURE-BUTTON"
                    icon={
                      <AddIcon
                        color={
                          props.auth.theme.primaryColor === "#0E0E0E"
                            ? "#0E0E0E"
                            : "#FFFFFF"
                        }
                      />
                    }
                    boxShadow={false}
                    onClick={() => {
                      props.navigate("/procedures/createProcedure");
                    }}
                    className="width-fit-content padding-left-large padding-right-large"
                  />
                </div>
              ) : (
                <></>
              )}
            </div>
          </div>

          <div
            ref={filterContainerRef}
            className="padding-top-larger display-flex flex-justify-content-space-between"
          >
            <div
              style={{ width: "90%", flexWrap: "wrap", gap: "8px" }}
              className="display-flex flex-align-items-center"
            >
              {/* <div>
                <SearchBox
                  title="SEARCH PROCEDURE"
                  placeHolder="SEARCH PROCEDURE"
                  value={props.table.procedures.searchKey}
                  onChange={(event) => {
                    props.setTableSearchKey("PROCEDURES", event.target.value);
                  }}
                  showCloseIcon={true}
                  closeOnClick={() => {
                    if (props.table.procedures.searchKey.length > 0) {
                      props.setTableSearchKey("PROCEDURES", "");
                    }
                  }}
                />
              </div>

              <FilterSeparator /> */}
              <div className="display-flex flex-align-items-center position-relative">
                <MultipleSelect
                  disabled={handleDisableFilter()}
                  loading={props.procedures.loading}
                  data-cy="TYPE-MULTI"
                  data={proceduresFilterData()[0]}
                  onResetClick={(key) => {
                    handleResetClick(key);
                  }}
                  setSelectedFilters={setSelectedFilters}
                  selectedFilters={selectedFilters}
                  appliedFilters={props.table.procedures.filter}
                  selected={selectedFilters["type"]}
                />
              </div>
            </div>

            {isFilterApplied(selectedFilters, "PROCEDURES").validation && (
              <div
                style={{
                  width: "10%"
                }}
                className={`display-flex flex-justify-content-space-between`}
              >
                <div
                  style={{
                    width: "60%"
                  }}
                >
                  <Button
                    data-cy="FILTER-APPLY-BUTTON"
                    text="Apply"
                    boxShadow={false}
                    variant="filter"
                    loading={props.loading}
                    className="inherit-parent-width padding-left-large padding-right-large"
                    onClick={() => {
                      handleApplyClick();
                    }}
                  />
                </div>
                <div
                  style={{
                    width: "40%"
                  }}
                >
                  <Button
                    data-cy="FILTER-RESET-BUTTON"
                    variant="transparent"
                    text="Clear"
                    boxShadow={false}
                    className="inherit-parent-width padding-left-large padding-right-large"
                    onClick={() => {
                      handleClearClick();
                    }}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
        <div
          style={{
            height: `calc(100% - ${height + 32}px`
          }}
        >
          {/* {!collapse && (
            <>
              <div className="display-flex flex-justify-content-space-between margin-top-larger">
                {InfoCardData.map((data, index) => (
                  <div key={index} style={{ width: "calc(100% / 3 - 20px)" }}>
                    <InfoCard data={data} />
                  </div>
                ))}
              </div>
              <div className="display-flex flex-justify-content-space-between padding-top-larger ">
                <GraphCard
                  title="OPERATION LOCATIONS"
                  graph={<DoughnutChart data={sampleDoughnutChartData} />}
                  legend={
                    <div className="display-flex flex-justify-content-center padding-top-large">
                      {sampleDoughnutChartData.datasets[0].backgroundColor.map(
                        (data, i) => (
                          <div key={i}>
                            <LegendCard
                              data={sampleDoughnutChartData}
                              color={data}
                              index={i}
                            />
                          </div>
                        )
                      )}
                    </div>
                  }
                />
                <GraphCard
                  title="OPERATION LOCATIONS"
                  graph={<DoughnutChart data={sampleDoughnutChartData} />}
                  legend={
                    <div className="display-flex flex-justify-content-center padding-top-large">
                      {sampleDoughnutChartData.datasets[0].backgroundColor.map(
                        (data, i) => (
                          <div key={i}>
                            <LegendCard
                              data={sampleDoughnutChartData}
                              color={data}
                              index={i}
                            />
                          </div>
                        )
                      )}
                    </div>
                  }
                />
                <GraphCard
                  title="OPERATION LOCATIONS"
                  type="line"
                  graph={<LineChart data={sampleBarChartData} />}
                  legend={
                    <div
                      style={{
                        paddingTop: "31px"
                      }}
                    />
                  }
                />
              </div>
            </>
          )} */}

          {height && (
            <div
              style={{
                height: `calc(100% - ${collapse ? 0 : 420}px`
              }}
              className="padding-top-larger"
            >
              <Table
                title="ALL PROCEDURES"
                setCollapse={(data) => {
                  setCollapse(data);
                  if (tableContainerRef.current) {
                    tableContainerRef.current.scrollTop = 0;
                  }
                }}
                allowCollapse={false}
                collapse={collapse}
                headers={proceduresTableHeadings}
                onClick={(data) => {
                  if (data.procedureType !== "independentEngineer") {
                    props.setSelectedTableData("PROCEDURES", data.documentId);
                    props.navigate(`procedures/${data.documentId}`);
                  }
                }}
                data={
                  isValidObject(props.procedures.data)
                    ? convertToTableData(
                        Object.values(props.procedures.data)
                      ).slice(
                        !collapse ? 0 : (currentPage - 1) * 50,
                        !collapse ? 6 : currentPage * 50
                      )
                    : []
                }
                getField={procedureTableField}
                totalPage={
                  isValidObject(props.procedures.data)
                    ? Math.ceil(
                        Object.values(props.procedures.data).length / 50
                      ) || 1
                    : 1
                }
                currentPage={currentPage}
                previousPageOnClick={() => {
                  setCurrentPage(currentPage - 1);
                }}
                nextPageOnClick={() => {
                  setCurrentPage(currentPage + 1);
                }}
                resetAllClick={() => {
                  handleClearClick();
                }}
                sort={props.table.procedures.sort}
                handleSort={(title) => {
                  setCurrentPage(1);
                  props.setTableSort("PROCEDURES", {
                    title: title,
                    ascending:
                      props.table?.procedures?.sort?.title === title
                        ? !props.table?.procedures?.sort?.ascending
                        : true
                  });
                }}
                backgroundColor="background-color-primary"
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
}

const mapStateToProps = function(state) {
  return {
    auth: state.auth,
    locations: state.locations,
    table: state.table,
    workforce: state.workforce,
    procedures: state.procedures
  };
};

const mapDispatchToProps = function() {
  return {
    setSelectedTableData: (tableName, data) =>
      setSelectedTableData(tableName, data),
    setTableFilter: (tableName, data) => setTableFilter(tableName, data),
    setTableSort: (tableName, data) => setTableSort(tableName, data),
    setTableSearchKey: (tableName, value) =>
      setTableSearchKey(tableName, value),
    createProcedurePreset: (data, navigate) =>
      createProcedurePreset(data, navigate),
    editProcedurePreset: (data, navigate) => editProcedurePreset(data, navigate)
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Procedures);
